import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { ProfilesReducer } from "../reducers/ProfilesReducer";

const ProfilesContext = createContext({
	state: ProfilesReducer.getInitialState(),
	actions: ProfilesReducer.actions,
});

export const useProfilesContext = () => useContext(ProfilesContext);

export const ProfilesProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: ProfilesReducer.getInitialState(),
		reducers: ProfilesReducer.caseReducers,
	});

	return (
		<ProfilesContext.Provider value={{ state, actions }}>
			{children}
		</ProfilesContext.Provider>
	);
};
